<!-- Pug Template -->
<template lang="pug">
.vertical-card.card.d-flex.w-100.p-5.py-4.align-items-center.text-center.bg-gray-1.border-gray-2.rounded-bottom
	h2.h1 {{ vertical.name }}
	
	.flex-grow-1.card-text(
		v-html="replaceVerticalText(vertical.card_text, children)"
	)

	router-link.btn.btn-pill.btn-gray.btn-outline.btn-lg.font-sans(
		:to="{name:'vertical', params:{vertical_slug}}"
	) View all
		span.mdi.mdi-arrow-right.ml-2
	
</template>

<!-- Script -->
<script>
import store from './store';
import {replaceVerticalText} from './store';
export default {

	props: {
		vertical: {
			type: Object,
			required: true
		}
	},

	data(){
		return {replaceVerticalText};
	},

	computed: {
		vertical_slug(){
			return this.vertical.slug;
		},
		stage(){
			return store.verticalById(this.vertical.id).stage;
		},
		parent(){
			return this.vertical.parent ? store.verticalById(this.vertical.parent) : null;
		},
		children(){
			return this.stage.verticals.filter( v => v.parent == this.vertical.id );
		},
	}
};
</script>

<!-- SCSS Style -->
<style lang="scss" scoped>
.vertical-card {
	aspect-ratio: 2/1;
	.card-text::v-deep a {
		color: inherit;
		text-decoration: underline;
		font-weight: bold;
	}
}
</style>